"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.HashtagIcon = exports.UnreadDot = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var styled_1 = require("@hiyllo/ux/styled");
var platform_1 = require("@hiyllo/ux/platform");
var react_native_1 = require("react-native");
var pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
var theme_1 = require("@hiyllo/ux/theme");
var HashtagItemContainer = (0, styled_1.styledRN)(react_native_1.View, function (_a) {
    var $theme = _a.$theme;
    return ({
        backgroundColor: $theme.midground,
        height: 20,
        width: 20,
        flexShrink: 0,
        borderRadius: 5,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        color: $theme.foreground
    });
});
exports.UnreadDot = (0, styled_1.styledRN)(react_native_1.View, {
    position: "absolute",
    bottom: -5,
    right: -5,
    backgroundColor: "red",
    height: 10,
    width: 10,
    borderRadius: 5
});
exports.HashtagIcon = react_1["default"].memo(function HashtagIcon() {
    var FontAwesomeIcon = (0, platform_1.useFontAwesomeIcon)();
    var $theme = (0, theme_1.useTheme)();
    return ((0, jsx_runtime_1.jsx)(HashtagItemContainer, { children: (0, jsx_runtime_1.jsx)(FontAwesomeIcon, { icon: pro_light_svg_icons_1.faHashtag, size: 12, color: $theme.foreground }) }));
});
